import { defineComponent as c, createElementBlock as o, openBlock as n, Fragment as i, renderList as u, normalizeClass as d, createBlock as m, createCommentVNode as f, resolveDynamicComponent as p, toRaw as _ } from "vue";
const I = { class: "w-full list-none" }, h = ["id", "aria-hidden"], v = /* @__PURE__ */ c({
  name: "RevCarouselItems",
  __name: "CarouselItems",
  props: {
    currentIndex: {},
    currentIndexId: {},
    items: {}
  },
  setup(l) {
    const s = l;
    function t(r) {
      return r === s.currentIndex;
    }
    return (r, k) => (n(), o("ul", I, [
      (n(!0), o(i, null, u(r.items, (a, e) => (n(), o("li", {
        id: t(e) ? s.currentIndexId : void 0,
        key: e,
        "aria-hidden": !t(e),
        class: d(["flex w-full list-none justify-center motion-safe:animate-fade-in", t(e) ? "block" : "hidden"])
      }, [
        a !== null ? (n(), m(p(_(a)), { key: 0 })) : f("", !0)
      ], 10, h))), 128))
    ]));
  }
});
export {
  v as default
};
